export const styles = {
  wrapper: {
    position: 'relative',
  },
  loadingWrapper: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    backgroundColor: 'rgba(0,0,0,0.45)',
    color: '#fff',
  },
}
